export const theme = {
  bgColor:"#f6f1f7",
  main:"#008000",
  white:"white",
  black:"#000000",
  adBg:"#849a72",
  secColor: "#353535",
  thirdColor: "#2D2D2D",
  sliderShadow: "rgba(217, 217, 217, 1)",
  color4: "#2B2B2B",
  main2: "#6D966D",
  red: 'red',
  shadowColor:'rgba(0, 0, 0, 0.25)',
  mainFont:"Poppins",
  testFont: "Playfair Display",
};

export const sizes = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "414px",
  tablet: "768px",
  laptop: "992px",
  laptopL: "1200px",
  desktop: "1440px",
  desktopL: "1680px",
  desktopXL: "1920px",
};
